import LocalStorageDao from "./localstorage-dao";

export const userInfo = state => state.userInfo;

export const userToken = state => state.userToken;

export const loginInfo = state => state.loginInfo;

export const device = state => state.device;

export const tabBar = state => state.tabBar;

export const userId = state => state.userInfo ? state.userInfo.id : '';

export const serverType = state => state.serverType;

export const tatId = state => state.tatId;

export const innerTabBar = state => state.innerTabBar;

export const alivePage = state => state.alivePage;

export const btnPerm = state => state.btnPerm;

export const reloadChnRateList = state => state.reloadChnRateList;

export const reloadAppAreaList = state => state.reloadAppAreaList;

export const reloadTatNameList = state => state.reloadTatNameList;

export const tatSimpleNames = state => state.tatSimpleNames;

export const reloadPage = state => state.reloadPage;

export const currentOrgDetail = state => state.currentOrgDetail;

export const isLoading = state => state.isLoading;

export const basicInfoFlag = state => state.basicInfoFlag;





// WEBPACK FOOTER //
// ./src/store/dao/getters.js